import React, { FunctionComponent } from 'react';
import ErrorView from 'components/ErrorView';
import useNavigator from 'hooks/useNavigator';
import useCommon from 'hooks/useCommon';
import { capitalize } from 'libs/utils';
import { useLocation } from 'react-router-dom';

const Success: FunctionComponent = () => {
  const { title } = useCommon();
  const { navigateCallback } = useNavigator();
  const { parkingMustApproved } = (useLocation().state || {}) as { parkingMustApproved?: boolean };

  return (
    <ErrorView
      title={
        parkingMustApproved
          ? 'Your parking registration has been submitted and is pending approval.'
          : 'Your parking registration has been submitted successfully.'
      }
      message={
        parkingMustApproved
          ? 'You will receive an SMS confirmation once it has been reviewed.'
          : "There's no need for anything else at this time."
      }
      actionTitle={capitalize(title)}
      onClick={navigateCallback('/')}
    />
  );
};

export default Success;
